"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const react_router_1 = require("react-router");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const companyQuery_1 = require("../../../../queries/companyQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const pageLoader_1 = __importDefault(require("../../../../router/loaders/pageLoader"));
const peopleTable_1 = __importDefault(require("../../../organisms/createTeamModal/peopleTable"));
const footer_1 = __importDefault(require("../../../organisms/footer"));
const useTeamState_1 = require("../../companySettings/teams/hooks/useTeamState");
const UserDetailsAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../../organisms/createTeamModal/userDetailsAside'))));
const AddDefaultManagerAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../../organisms/createTeamModal/addDefaultManagerAside'))));
const SelectRoleAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./selectRoleAside'))));
const AddPeopleAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../../organisms/createTeamModal/addPeople/addPeopleAside'))));
const TeamSettingsPeopleTemplate = () => {
    const usersLimit = appConstants_1.teams.USERLIMIT;
    const state = (0, useTeamState_1.useTeamState)();
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: teamId } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'),
        initialData: initialData.teamId,
    });
    const { data: userData } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.getTeamUsersQuery)({ teamId: teamId?.[0] || '' }),
        initialData: initialData.userData,
    });
    const { data: whitelistedDomainsData } = (0, companyQuery_1.useGetCompanyPropertyWhitelistedDomainsQuery)(initialData.user.companyAccountId || state.company.companyId);
    const isAlertMemoized = (0, react_1.useMemo)(() => {
        const usersDataLength = userData?.users?.length || 0;
        return usersDataLength > 1 && usersDataLength >= usersLimit;
    }, [userData?.users?.length, usersLimit]);
    const memoizedWhitelistedDomainsData = (0, react_1.useMemo)(() => {
        return whitelistedDomainsData || [];
    }, [whitelistedDomainsData]);
    const disabled = (0, react_1.useMemo)(() => {
        return ((state.company.features?.ENABLE_DOMAIN_WHITELISTING && [...memoizedWhitelistedDomainsData].length === 0) ||
            isAlertMemoized);
    }, [state.company.features?.ENABLE_DOMAIN_WHITELISTING, isAlertMemoized, memoizedWhitelistedDomainsData]);
    (0, react_1.useEffect)(() => {
        state.setFooterButtons([
            {
                id: 'invitePeople',
                dataTestId: 'invitePeople-btn',
                label: strings_1.teamSettingsPeopleStrings.INVITE_PEOPLE,
                color: uiConstants_1.UI_BUTTON_PRIMARY,
                disabled,
                onclick: () => state.setIsAddPeopleAsideOpen(true),
            },
        ]);
    }, [disabled, state.setIsInvitePeopleAsideOpen, state.setFooterButtons]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Paper, { "ts-variant": "container", children: [isAlertMemoized && ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "info", variant: "filled", "ts-variant": "purple-note", sx: { marginBottom: '10px' }, children: strings_1.messageStrings.WARNING_MESSAGE })), (0, jsx_runtime_1.jsx)(peopleTable_1.default, {}), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(UserDetailsAside, {}) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(AddDefaultManagerAside, {}) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: (0, jsx_runtime_1.jsx)(SelectRoleAside, {}) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}), children: (0, jsx_runtime_1.jsx)(AddPeopleAside, {}) })] }), (0, jsx_runtime_1.jsx)(footer_1.default, {})] }));
};
exports.default = TeamSettingsPeopleTemplate;
